<template>
  <main>
    <div class="row add-paiement">
      <div class="col-md-12">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>{{ $t('title.addPayment') }}</h3>
          </template>

          <template v-slot:right-element>
            <a class="btn btn-outline-primary button" @click="$router.go(-1)">
              <i class="arrow left" /> {{ $t('button.retour') }}
            </a>
          </template>
        </TopTemplate>
        <div v-if="is_created" class="alert alert-success" role="alert">
          {{ $t("info.successPayment") }}
        </div>
        <div class="ajout-container message-add">
          <form novalidate @submit.prevent="onSubmitCreatePayment">
            <div class="row">
              <div class="col-md-12 p-3 select-wrapper">
                <div class="ajout-container__simple">
                  <label>
                    {{ $t('paiement.form.name') }}
                    <sup class="etoile">*</sup>
                  </label>
                </div>
                <input v-model="parent" class="form-control p-2" disabled />
              </div>
              <div class="col-md-6 p-3">
                <div class="ajout-container__simple">
                  <label>{{ $t('paiement.form.montant') }} <sup class="etoile">*</sup></label>
                  <input
                    v-model.number="payment.amount"
                    type="number"
                    @input="limitInputToSixDigits"
                    @keydown="portKeydown($event)"
                    :reduce="(option) => option.id"
                    class="form-control p-2"
                    :class="
                              v$.payment.amount.$error ? 'is-invalid' : ''
                            "
                          />
                          <span
                            v-if="v$.payment.amount.$error"
                            class="invalid-feedback"
                          >
                            {{ v$.payment.amount.$errors[0].$message }}
                          </span>
                </div>
              </div>
              <div class="col-md-6 p-3">
                <div class="ajout-container__multiple">
                  <div class="ajout-container__simple">
                    <label>{{ $t('paiement.form.date') }}</label>
                    <Datepicker
                      v-model="payment.payment_date"
                      autoApply
                      :enableTimePicker="false"
                      locale="fr"
                      :format="format_date_v1"
                      @update:modelValue="formatByDate"
                    />
                  </div>
                </div>
              </div>
              <br />
              <div class="col-12 p-3">
                <div class="ajout-container__multiple">
                  <div class="ajout-container__simple">
                    <label>{{ $t('paiement.form.note') }}</label>
                  </div>
                  <textarea
                    v-model="payment.description"
                   
                    class="form-control p-2 espace_heigth"
                    maxlength="300"
                  />
                  <span class="invalid-feedback"> </span>
                  <label class="indice">{{ $t('info.sizeText') }}</label>
                </div>
              </div>
              <div class="col-12 button-envoyer text-right">
                <button
                  type="submit"
                  class="btn button btn-primary"
                  :disabled="submited"
                >
                  <i class="icon-Check"></i>
                  {{ $t('button.confirm') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import { required, maxLength, helpers, numeric } from "@vuelidate/validators";
import PaymentService from "../../services/payment.service";
import ParentService from "../../services/parent.service";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
import { ref } from "vue";
import StudentService from "../../services/student.service";
export default {
  name: "AddPrix",
  components: {
    TopTemplate,
    "v-select": vSelect,
    Datepicker,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };
    const flow = ref(["year", "calendar"]);
    return {
      format,
      flow,
    };
  },
  created() {
    this.referenceId = this.$route.params.id;
    /* this.getDetails();
     */
  },
  data() {
    return {
      v$: useValidate(),
      submited:false,
      payment: new Form({
        amount: null,
        payment_date: ref(new Date()),
        description: "",
      }),
      referenceId: null,
      params: {
        q: "",
        limit: 15,
        page: 1,
        sort: "created_at",
        order: false,
        class_type_id: [],
        class_school_id: [],
        school_id: "",
        birthday: null,
        datede: null,
        selected_status_id: null,
        selected_system_id: null,
        selected_school_id: null,
        hasfilter: false,
      },
      parent: "",
      fullname: "",
      reference: {},
      is_created: false,
      loading: false,
      // requiredDescriptionLength: 300
    };
  },
  validations() {
    return {
      payment: {
        /* parent: {
            required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
        }, */
        amount: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
          //numeric: helpers.withMessage(this.$t("validation.numeric"), numeric),
          // maxLength: maxLength(this.requiredDescriptionLength),
        },
      },
    };
  },
  mounted() {
    this.getDetails();
  },

  methods: {
    limitInputToSixDigits(event) {
      if (event.target.value.length > 6) {
        this.payment.amount = parseInt(event.target.value.substring(0, 6));
      }
    },
    portKeydown(e) {
      if (e.key ==="e") {
        e.preventDefault();
      }
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    getDetails() {
      // this.loading = true;
      StudentService.get(this.referenceId)
        .then((response) => {
          this.reference = response.data.data;
          this.parent =
            this.reference.first_name + " " + this.reference.last_name;
            
        })
        .catch((error) => {
          console.error(error)
        });
    },
    formatByDate: _.debounce(function () {
      if (this.payment.payment_date != null) {
        this.payment.payment_date = this.dateTime(this.payment.payment_date);
      }
    }, 200),
    onSubmitCreatePayment() {
      this.submited= true;
      this.v$.$validate();

      if (!this.v$.$error) {
        const data = {
          payment_date: moment(this.payment.payment_date).format("YYYY-MM-DD"),
          amount: this.payment.amount,
          description: this.payment.description,
          wording:this.payment.description
        };

        PaymentService.create(data, this.referenceId)
          .then((response) => {
            this.is_created = true;
            this.submited= false;
            this.loading = false;
            this.scrollToTop();
            this.$router.push({name:"DetailsPayment"})
          })
          .then(() => {
            this.$nextTick(() => {
              this.resetForm();
              //this.student.reset();
              setTimeout(() => {
                this.v$.$reset();
              }, 0);
            });
          })
          .catch((error) => {
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          });
      }
    },
    ListParents() {
      ParentService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          q: this.params.q,
          sort: this.params.sort,
          status: this.params.selected_status_id,
          app_system: this.params.selected_system_id,
          school_id: this.params.school_id,
          school: this.params.selected_school_id,
        },
      }).then(
        (response) => {
          this.parents = response.data.data;
          this.parents.id = response.data.data.id;
          this.parents.fullName = `${response.data.data.last_name} ${response.data.data.first_name} `;
        },
        (error) => {}
      );
    },
    handleInput() {
      this.readInput = false;
      if (this.payment.payment_date != null) {
        this.payment.payment_date = this.dateTime(this.payment.payment_date);
      }
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    resetForm() {
      this.payment.amount = "";
      this.payment.payment_date = "";
      this.payment.description = "";
    },
  },
};
</script>
<style scoped>
.indice {
    font-size: 11px;
    color: #36b7b9;
    font-style: italic;
    line-height: 15px;
    display: block;
}</style>